import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { FwdRiskPair } from "shared/cubiq-services/lookup/model/impl/bmrisk/FwdRiskModel";
import {
  SpotRiskPair,
  ValueDateTotalInfo,
} from "shared/cubiq-services/lookup/model/impl/bmrisk/SpotRiskModel";

export abstract class BmarkBaseRiskDisplayModel {
  public id: string = null;
  public ccyPair: string = null;
  public instrument: string = null;
  public baseCcy: string = null;
  public nonBaseCcy: string = null;
  //
  public total: CubiqTS.BigNumber = null;
  public totalInternal: CubiqTS.BigNumber = null;
  public totalInternalOrdersCount: number = 0;
  public totalExternal: CubiqTS.BigNumber = null;
  public totalExternalOrdersCount: number = 0;
  public tgData: Array<BmarkRiskTGDisplayModel> = new Array<BmarkRiskTGDisplayModel>();
  public pricingError: BmarkRiskPricingErrorDisplayModel = null;
  //
  public notation: CubiqTS.PositionUnit = null;
  public isMaterial: boolean = false;
  public precision: number = 2;
  public fullPrecision: number = 2;

  public isPositionWarning: boolean = false;
  public isPositionAlert: boolean = false;
  constructor(id: string) {
    this.id = id; // fixing + ccypair
  }
  /**
   * Get the list of value date aggregates sorted by value date
   * @returns
   */
  public abstract getValueDataTotalInfos(): ValueDateTotalInfo[];

  /**
   * Does this pair have any non-spot allocations?
   * @returns
   */
  public abstract hasFwdOrders(): boolean;

  /**
   * Are any risks for this pair missing their NPV amounts
   */
  public abstract hasNPVWarning(): boolean;
}

export class BmarkSpotRiskDisplayModel extends BmarkBaseRiskDisplayModel {
  /**
   * Keep a live reference to the underlying data model so we can calculate the
   * the value date totals on demand
   * @param id
   * @param pairModel
   */
  constructor(
    id: string,
    private pairModel: SpotRiskPair,
  ) {
    super(id);
  }

  /**
   * Get the list of value date aggregates sorted by value date
   * @returns
   */
  public override getValueDataTotalInfos(): ValueDateTotalInfo[] {
    return this.pairModel.getValueDateTotalInfos();
  }

  /**
   * Does this pair have any non-spot allocations?
   * @returns
   */
  public override hasFwdOrders(): boolean {
    return this.pairModel.hasFwdOrders();
  }

  /**
   * Are any risks for this pair missing their NPV amounts
   */
  public override hasNPVWarning(): boolean {
    return this.pairModel.hasNpvWarning();
  }
}

export class BmarkRiskTGDisplayModel {
  public tgName: string = null;
  public tgId: CubiqTS.Long = null;
  public totalAmount: CubiqTS.BigNumber = null;
  public fillAmount: CubiqTS.BigNumber = null;
  public outstandingAmount: CubiqTS.BigNumber = null;
  public orderCount: number = 0;
  public hasActiveOrders: boolean = true;
  public isBmarkExternal: boolean = false;
}

export class BmarkRiskPricingErrorDisplayModel {
  public tgData: Array<BmarkRiskTGDisplayModel> = new Array<BmarkRiskTGDisplayModel>();
  public orderCount: number = 0;
  public totalAmount: CubiqTS.BigNumber = new CubiqTS.BigNumber(0);
}

export class BmarkFwdRiskDisplayModel extends BmarkBaseRiskDisplayModel {
  /**
   * Keep a live reference to the underlying data model so we can calculate the
   * the value date totals on demand
   * @param id
   * @param pairModel
   */
  constructor(
    id: string,
    private pairModel: FwdRiskPair,
  ) {
    super(id);
  }

  /**
   * Does this pair have any non-spot allocations?
   * @returns
   */
  public override hasFwdOrders(): boolean {
    return false;
  }

  /**
   * Are any risks for this pair missing their NPV amounts
   */
  public override hasNPVWarning(): boolean {
    return false;
  }

  /**
   * Get the list of value date aggregates sorted by value date
   * @returns
   */
  public override getValueDataTotalInfos(): ValueDateTotalInfo[] {
    return [];
  }

  /**
   * Get the Fwd Risk value date
   */
  public getValueDate(): CubiqTS.Moment {
    return this.pairModel.valueDate;
  }

  /**
   * Get the Fwd Risk value date
   */
  public getTenor(): CubiqTS.Tenor {
    return this.pairModel.tenor;
  }
}
